import React from 'react'
import { framerHover1, framerHover2, hoverAnimationCSS, installFramer } from './code';
import './style.css'
import CodeHighlight from '../../components/CodeHighlight';
import { motion } from 'framer-motion';
import { TbArrowBackUpDouble } from 'react-icons/tb';

function Hover() {
  const [isActive, setIsActive] = React.useState(false)
  return (
    <div className='w-screen bg-[#1e1e1e] text-white overflow-auto flex items-center justify-center h-screen'>
      <div className='w-full max-w-[1200px] no-scrollbar h-screen overflow-auto py-6 px-2'>
        <div className='flex flex-col gap-4'>
          <div className='flex flex-col gap-4'>
            <a href='/' className='text-2xl md:text-3xl flex items-center gap-2 text-neutral-200'>
              <TbArrowBackUpDouble/>
              Hover Animation</a>
            <span className='text-neutral-300 text-justify'>Hover Animation with Framer Motion is a technique where animations are triggered when a user hovers over an element, using the Framer Motion library in React. With Framer Motion, you can easily implement smooth and responsive hover effects such as scaling up an element, changing its opacity, rotating it, or translat.ing it.
            </span>
          </div>
          <span>CSS Hover Pseudo-class : </span>
          <CodeHighlight
            code={hoverAnimationCSS}
            title="example.css"
            language="css"
          />

          <span>Result : </span>
          <div className='w-full h-[100px] rounded-lg flex items-center justify-center bg-neutral-700'>
            <button className='component bg-red-500 px-3 py-1 rounded-lg'>Hover Me</button>
          </div>

          <span className='text-neutral-300 text-justify'>In simple animations like the one above, most people might think that using CSS is better than a library such as Framer Motion, but when the animation used starts to become complex and there are many conditions that will be used to call the animation, CSS will require more complicated manual handling. Apart from that, to change the animation a little, the developers have to change and recreate the class so that there are no clashes between components.</span>

          <CodeHighlight
            code={installFramer}
            title="terminal"
            language="css"
          />

          <span>Framer Motion Hover : </span>
          <CodeHighlight
            code={framerHover1}
            title="example.js"
            language="css"
          />

          <span>Result : </span>
          <div className='w-full h-[100px] rounded-lg flex items-center justify-center bg-neutral-700'>
            <motion.button
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
              className='bg-red-500 px-3 py-1 rounded-lg'>Hover Me</motion.button>
          </div>

          <span className='text-neutral-300 text-justify'>with framer motion you can combine many styles and can even be combined with conditions if you need it, you can also change the animation variants that will be displayed according to your wishes</span>

          <span>Framer Motion Hover Condition : </span>
          <CodeHighlight
            code={framerHover2}
            title="example.js"
            language="css"
          />

          <span>Result : </span>
          <div className='w-full h-[100px] rounded-lg flex items-center gap-2 md:gap-8 justify-center bg-neutral-700'>
            <button onClick={() => setIsActive(!isActive)} className='bg-blue-400 py-1 rounded-lg px-2'>{`state : ${isActive}`}</button> :
            <motion.button
              whileHover={{ scale: isActive ? 0.5 : 1.2 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
              className='bg-red-500 px-3 py-1 rounded-lg'>Hover Me</motion.button>

            <motion.button
              whileHover={{ rotate: isActive ? -50 : 50 }}
              whileTap={{ scale: 0.9, rotate: isActive ? -180 : 180 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
              className='bg-red-500 px-3 py-1 rounded-lg'>Hover Me</motion.button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hover
